import useSWR from "swr"
import * as FailedDeliveryApi from "../../../apis/failed-delivery"

// Fetch the count of exceptions for each lifecycle stage in parallel.
// limit=1 keeps payload tiny — only `count` is consumed.
export const useFailedStatusCounts = () => {
  const { data, isLoading, mutate } = useSWR(
    "swr.failed-deliveries.counts",
    async () => {
      const [openRes, escRes, resRes] = await Promise.all([
        FailedDeliveryApi.list({ status: "OPEN", limit: 1 }),
        FailedDeliveryApi.list({ status: "ESCALATED", limit: 1 }),
        FailedDeliveryApi.list({ status: "RESOLVED", limit: 1 }),
      ])
      return {
        OPEN:      openRes.count,
        ESCALATED: escRes.count,
        RESOLVED:  resRes.count,
      }
    },
    { revalidateOnFocus: false, refreshInterval: 30_000 },
  )
  return { counts: data, isLoading, refresh: mutate }
}
